import React from 'react'
import { styled } from 'linaria/react'
import { theme } from '../../../Theme'
import CategoryTagsContainer from '../../../CategoryPage/CategoryTagsContainer'
import CategoryFallback from '../../../../svg/fallback-category.webp'
import { Breadcrumbs } from '../../BreadCrumbs/BreadCrumbs'
import Collapsible from '../Collapsible'
// import { stringByPropertyNameHasValidValue } from '../../Util/Helpers'

const HeroContainer = styled.div`
   position: relative;

   .page-hero-title {
      display: block;
      font-size: 2rem;
      color: #fff;
      text-shadow: 0 0 2rem #000;
      ${theme.below.sm} {
         font-size: 1.6em;
      }
   }

   .page-hero-mobile-description {
      width: 100%;

      ${theme.below.xl} {
         padding-left: 4rem;
         padding-right: 4rem;
         padding-bottom: 1.5rem;
      }

      ${theme.below.md} {
         padding-right: 1.5rem;
         padding-left: 1.5rem;
         padding-bottom: 1rem;
      }
   }

   .page-hero-mobile-separator {
      background-color: white;
      opacity: 0.8;
      width: 100%;
      height: 1px;
   }

   .page-hero-second {
      position: relative;
      border-radius: 0 !important;
      overflow: hidden;
   }

   .page-hero-second .img-background {
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      height: 100%;
      width: 100%;
      object-fit: cover;
   }

   .page-hero-first {
      order: 2;
   }

   article.collapsible-card-wrapper > div {
      max-width: 700px;
   }
`

const MobileOverlayBottom = styled.div`
   height: 100%;
   bottom: 0;
   width: 100%;
   z-index: 1;
   display: inline-block;
   position: absolute;

   background: ${props =>
      props.showDescriptionContent
         ? 'linear-gradient(180deg, rgba(0, 0, 0, 0.5) 50%,rgba(0, 0, 0, 1) 100%)'
         : 'linear-gradient(180deg, rgba(0, 0, 0, 0) 50%,rgba(0, 0, 0, 0.85) 100%)'};
`
const MobileOverlayTopGradient = styled.div`
   height: 120px;
   top: 0;
   width: 100%;
   z-index: 1;
   display: inline-block;
   position: absolute;

   background: ${props =>
      props.showDescriptionContent
         ? 'linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.75) 60%, rgba(255,255,255,0) 100%)'
         : ''};
`
const BreadCrumbsContainerMobile = styled.div`
   .breadcrumb li a {
      color: ${props => (props.showDescriptionContent ? 'black' : 'white')} !important;
   }

   .breadcrumb li {
      color: ${props => (props.showDescriptionContent ? 'black' : 'white')} !important;
   }

   ${theme.below.xl} {
      padding: ${props =>
         props.showDescriptionContent ? '2rem 0rem 1rem 4rem' : '9rem 0rem 0rem 4rem'};
   }

   ${theme.below.md} {
      padding: ${props =>
         props.showDescriptionContent
            ? '3rem 0rem 0.5rem 1.5rem'
            : '7rem 0rem 0rem 1.5rem'};
   }
`

const BlogMobileBanner = ({
   bannerContent,
   showDescriptionContent,
   activeCategory,
   parents,
   imageUrl,
   hideCategoryTags
}) => {

   const titleRow = (
      <div className="d-flex position-relative justify-content-between align-items-center z-2 px-128 py-8">
         <h1 className="page-hero-title">{activeCategory?.name}</h1>
      </div>
   )

   const mobileDescription = (
      <div className="page-hero-mobile-description d-flex flex-column gap-3 position-relative z-2">
         <span className="page-hero-mobile-separator"></span>
         <Collapsible
            content={bannerContent}
            open={false}
            closedVisibleHeight={80} 
         ></Collapsible>
      </div>
   )

   const backgroundOverlays = (
      <>
         <MobileOverlayBottom showDescriptionContent={showDescriptionContent} />
         <MobileOverlayTopGradient showDescriptionContent={showDescriptionContent} />
      </>
   )

   return (
      <HeroContainer className="d-xl-none" showDescriptionContent={showDescriptionContent}>
         <div className="row p-0 m-0">
            <div className="page-hero-second col-12 col-xl-6 p-0">
               <div className="page-hero-image">
                  <BreadCrumbsContainerMobile showDescriptionContent={showDescriptionContent}>
                     <Breadcrumbs
                        hideLast 
                        parents={parents}
                        title={
                           activeCategory?.breadcrumbText ||
                           activeCategory?.name
                        }
                        className="breadcrumb position-relative z-2 m-0"
                     />
                  </BreadCrumbsContainerMobile>
                  {titleRow}
                  {showDescriptionContent && mobileDescription}
                  <img
                     className="img-background img-fluid"
                     src={imageUrl ?? CategoryFallback}
                     alt={activeCategory?.name}
                  />
                  {backgroundOverlays}
               </div>
            </div>
            {!hideCategoryTags && (
               <div className="page-hero-first col-12 col-xl-6 pt-16 pr-32 pl-128 d-flex flex-column justify-content-between">
                  <div className="page-hero-first-top d-flex flex-column"></div>
                  <div className="page-hero-first-bottom d-flex flex-column">
                     <CategoryTagsContainer
                        category={activeCategory}
                     ></CategoryTagsContainer>
                  </div>
               </div>
            )}
         </div>
      </HeroContainer>
   )
}

export default BlogMobileBanner
